import { TKey } from '~/src/dash/publicaUI';

export type BidErrorKey =
  | 'BidUndefined'
  | 'BidTimeoutError'
  | 'BidBadInputError'
  | 'BidBadServerResponseError'
  | 'BidFailedToRequestBidsError'
  | 'BidAuctionFailed'
  | 'BidRateLimitBlocked'
  | 'BidFailedToParseResponse'
  | 'BidConnectionError'
  | 'BidPanic'
  | 'BidPrebidError'
  | 'BidEmptyResponseError'
  | 'BidNoContent204Error'
  | 'BidNoFillError'
  | 'BidEmptyVastError'
  | 'BidVastValidateError'
  | 'BidCachePutCacheMiss'
  | 'BidUnwrapTimeoutError'
  | 'BidPriceBelowFloor'
  | 'BidUnknownError'
  | 'BidRejectedUnknown'
  | 'BidRejectedDuration'
  | 'BidRejectedDupMediafileUrl'
  | 'BidRejectedDupAdomain'
  | 'BidRejectedDupCategory'
  | 'BidRejectedCacheId'
  | 'BidRejectedPrice'
  | 'BidRejectedAdvertiserBlocklist'
  | 'BidRejectedIabCatBlocklist'
  | 'BidRejectedAdomainMissing'
  | 'BidRejectedAboveMaxAdDuration'
  | 'BidRejectedBelowMinAdDuration'
  | 'BidNoMediafileSatisfySiteMaxBitrate'
  | 'BidRejectedPodFloor'
  | 'BidRejectedAllHouseAds'
  | 'BidRejectedDupAdId'
  | 'BidRejectedDupCreativeId'
  | 'BidNoMediafileSatisfyEndpointMaxBitrate'
  | 'BidNoMediafileSatisfyEndpointMinBitrate'
  | 'BidNoMediafileSatisfySiteMinBitrate'
  | 'BidRejectedBrandSafetyRuleBlock'
  | 'BidRejectedMinPodSizeNotMeet'
  | 'BidRejectedDupBidCatExclusion'
  | 'BidRejectedTooManyBidCatExclusion'
  | 'BidPriceMissing'
  | 'BidBidderNotSharedInventory'
  | 'BidRejectedDupAdomainElea'
  | 'BidRejectedDupAdomainClickThrough'
  | 'BidRejectedDupCategoryElea'
  | 'BidRejectedPriceAboveErrorThreshold'
  | 'BidRejectedDupCampaignId'
  | 'BidRejectedDupApsKey'
  | 'BidRejectedMediafileBlocklist'
  | 'BidRejectedNotFirstSlotInPod'
  | 'BidRejectedDupMediafileUrlNormal'
  | 'BidRejectedCreativeIdBlock'
  | 'BidRejectedNonsecureVast'
  | 'BidRejectedSlotTargetingMismatch'
  | 'BidInvalidRequestUrl'
  | 'BidRejectedCreativeBlockUnknown'
  | 'BidRejectedCreativeBlock404NotFound'
  | 'BidRejectedCreativeBlockMismatchDuration'
  | 'BidRejectedCreativeValidationRejected'
  | 'BidRejectedOverOrderFrequencyCap'
  | 'BidRejectedOverCampaignFrequencyCap'
  | 'BidSiteLoopError'
  | 'BidRejectedBlockedByAdvertiser'
  | 'BidRejectedAboveSharedPodDuration'
  | 'BidRejectedTier'
  | 'BidMaxUnwrapError'
  | 'BidRejectedLanguageBlocklist'
  | 'BidMissingVastMeta'
  | 'BidXmlSyntaxError'
  | 'BidRejectedAdvertiserRuleDoNotAir'
  | 'BidRejectedAdvertiserRuleCompetitiveSeparationSelf'
  | 'BidRejectedAdvertiserRuleCompetitiveSeparationOther'
  | 'BidRejectedDupPhiloAudioIdent'
  | 'BidInvalidMediafileDeliveryType'
  | 'BidRejectedCategoryExclusivity'
  | 'BidUnwrapEOFError'
  | 'BidRejectedCacheConnection'
  | 'BidRejectedCacheXmlEncode'
  | 'BidRejectedCacheStore'
  | 'BidConnectionErrorAlt'
  | 'BidRejectedEventTrackerBlocklist'
  | 'BidPriceTooHigh'
  | 'BidRejectedCreativeQualityAssurance'
  | 'BidRejectedPlatformConnectionBidderSlotTargetingMismatch'
  | 'BidRejectedBelowFloor'
  | 'CombineCreativeError'
  | 'ResponseEOFError'
  | 'BidConnectionResetByPeer'
  | 'GzipReadError'
  | 'UnwrapParseError'
  | 'MacroReplacementErrorCode';

export type CampaignNoFillErrorKey =
  | 'NoFillUndefined'
  | 'EmptyVast'
  | 'FrequencyCap'
  | 'Pacing'
  | 'SiteLoopError'
  | 'EmptyVastMediafile'
  | 'CreativeSelectionError'
  | 'ZeroDuration'
  | 'AdserverOrderNotFound'
  | 'LowPacing'
  | 'OrderFrequencyCap'
  | 'VastTimeout'
  | 'EmaPacing'
  | 'EmaPacingDataNotFound';

export const bidErrorKeyToTKeyMap: Record<BidErrorKey, TKey> = {
  BidUndefined: 'BidErrorCodeUndefined',
  BidTimeoutError: 'BidErrorCodeTimeoutError',
  BidBadInputError: 'BidErrorCodeBadInputError',
  BidBadServerResponseError: 'BidErrorCodeBadServerResponseError',
  BidFailedToRequestBidsError: 'BidErrorCodeFailedToRequestBidsError',
  BidAuctionFailed: 'BidErrorCodeBidAuctionFailed',
  BidRateLimitBlocked: 'BidErrorCodeRateLimitBlocked',
  BidFailedToParseResponse: 'BidErrorCodeFailedToParseResponse',
  BidConnectionError: 'BidErrorCodeConnectionError',
  BidPanic: 'BidErrorCodePanic',
  BidPrebidError: 'BidErrorCodePrebidError',
  BidEmptyResponseError: 'BidErrorCodeEmptyResponseError',
  BidNoContent204Error: 'BidErrorCodeNoContent204Error',
  BidNoFillError: 'BidErrorCodeNoFillError',
  BidEmptyVastError: 'BidErrorCodeEmptyVastError',
  BidVastValidateError: 'BidErrorCodeVastValidateError',
  BidCachePutCacheMiss: 'BidErrorCodeCachePutCacheMiss',
  BidUnwrapTimeoutError: 'BidErrorCodeUnwrapTimeoutError',
  BidPriceBelowFloor: 'BidErrorCodeBidPriceBelowFloor',
  BidUnknownError: 'BidErrorCodeUnknownError',
  BidRejectedUnknown: 'BidErrorCodeBidRejectedUnknown',
  BidRejectedDuration: 'BidErrorCodeBidRejectedDuration',
  BidRejectedDupMediafileUrl: 'BidErrorCodeBidRejectedDupMediafileURL',
  BidRejectedDupAdomain: 'BidErrorCodeBidRejectedDupAdomain',
  BidRejectedDupCategory: 'BidErrorCodeBidRejectedDupCategory',
  BidRejectedCacheId: 'BidErrorCodeBidRejectedCacheID',
  BidRejectedPrice: 'BidErrorCodeBidRejectedPrice',
  BidRejectedAdvertiserBlocklist: 'BidErrorCodeBidRejectedAdvertiserBlocklist',
  BidRejectedIabCatBlocklist: 'BidErrorCodeBidRejectedIABCatBlocklist',
  BidRejectedAdomainMissing: 'BidErrorCodeBidRejectedAdomainMissing',
  BidRejectedAboveMaxAdDuration: 'BidErrorCodeBidRejectedAboveMaxAdDuration',
  BidRejectedBelowMinAdDuration: 'BidErrorCodeBidRejectedBelowMinAdDuration',
  BidNoMediafileSatisfySiteMaxBitrate: 'BidErrorCodeNoMediafileSatisfySiteMaxBitrate',
  BidRejectedPodFloor: 'BidErrorCodeBidRejectedPodFloor',
  BidRejectedAllHouseAds: 'BidErrorCodeBidRejectedAllHouseAds',
  BidRejectedDupAdId: 'BidErrorCodeBidRejectedDupAdID',
  BidRejectedDupCreativeId: 'BidErrorCodeBidRejectedDupCreativeID',
  BidNoMediafileSatisfyEndpointMaxBitrate: 'BidErrorCodeNoMediafileSatisfyEndpointMaxBitrate',
  BidNoMediafileSatisfyEndpointMinBitrate: 'BidErrorCodeNoMediafileSatisfyEndpointMinBitrate',
  BidNoMediafileSatisfySiteMinBitrate: 'BidErrorCodeNoMediafileSatisfySiteMinBitrate',
  BidRejectedBrandSafetyRuleBlock: 'BidErrorCodeBidRejectedBrandSafetyRuleBlock',
  BidRejectedMinPodSizeNotMeet: 'BidErrorCodeBidRejectedMinPodSizeNotMeet',
  BidRejectedDupBidCatExclusion: 'BidErrorCodeBidRejectedDupBidCatExclusion',
  BidRejectedTooManyBidCatExclusion: 'BidErrorCodeBidRejectedTooManyBidCatExclusion',
  BidPriceMissing: 'BidErrorCodeBidPriceMissing',
  BidBidderNotSharedInventory: 'BidErrorCodeBidderNotSharedInventory',
  BidRejectedDupAdomainElea: 'BidErrorCodeBidRejectedDupAdomainElea',
  BidRejectedDupAdomainClickThrough: 'BidErrorCodeBidRejectedDupAdomainClickThrough',
  BidRejectedDupCategoryElea: 'BidErrorCodeBidRejectedDupCategoryElea',
  BidRejectedPriceAboveErrorThreshold: 'BidErrorCodeBidRejectedPriceAboveErrorThreshold',
  BidRejectedDupCampaignId: 'BidErrorCodeBidRejectedDupCampaignID',
  BidRejectedDupApsKey: 'BidErrorCodeBidRejectedDupAPSKey',
  BidRejectedMediafileBlocklist: 'BidErrorCodeBidRejectedMediafileBlocklist',
  BidRejectedNotFirstSlotInPod: 'BidErrorCodeBidRejectedNotFirstSlotInPod',
  BidRejectedDupMediafileUrlNormal: 'BidErrorCodeBidRejectedDupMediafileURLNormal',
  BidRejectedCreativeIdBlock: 'BidErrorCodeBidRejectedCreativeIDBlock',
  BidRejectedNonsecureVast: 'BidErrorCodeBidRejectedNonsecureVAST',
  BidRejectedSlotTargetingMismatch: 'BidErrorCodeBidRejectedSlotTargetingMismatch',
  BidInvalidRequestUrl: 'BidErrorCodeInvalidRequestURL',
  BidRejectedCreativeBlockUnknown: 'BidErrorCodeBidRejectedCreativeBlockUnknown',
  BidRejectedCreativeBlock404NotFound: 'BidErrorCodeBidRejectedCreativeBlock404NotFound',
  BidRejectedCreativeBlockMismatchDuration: 'BidErrorCodeBidRejectedCreativeBlockMismatchDuration',
  BidRejectedCreativeValidationRejected: 'BidErrorCodeBidRejectedCreativeValidationRejected',
  BidRejectedOverOrderFrequencyCap: 'BidErrorCodeBidRejectedOverOrderFrequencyCap',
  BidRejectedOverCampaignFrequencyCap: 'BidErrorCodeBidRejectedOverCampaignFrequencyCap',
  BidSiteLoopError: 'BidErrorCodeBidSiteLoopError',
  BidRejectedBlockedByAdvertiser: 'BidErrorCodeBidRejectedBlockedByAdvertiser',
  BidRejectedAboveSharedPodDuration: 'BidErrorCodeBidRejectedAboveSharedPodDuration',
  BidRejectedTier: 'BidErrorCodeBidRejectedTier',
  BidMaxUnwrapError: 'BidErrorCodeMaxUnwrapError',
  BidRejectedLanguageBlocklist: 'BidErrorCodeBidRejectedLanguageBlocklist',
  BidMissingVastMeta: 'BidErrorCodeBidMissingVastMeta',
  BidXmlSyntaxError: 'BidErrorCodeXMLSyntaxError',
  BidRejectedAdvertiserRuleDoNotAir: 'BidErrorCodeBidRejectedAdvertiserRuleDoNotAir',
  BidRejectedAdvertiserRuleCompetitiveSeparationSelf:
    'BidErrorCodeBidRejectedAdvertiserRuleCompetitiveSeparationSelf',
  BidRejectedAdvertiserRuleCompetitiveSeparationOther:
    'BidErrorCodeBidRejectedAdvertiserRuleCompetitiveSeparationOther',
  BidRejectedDupPhiloAudioIdent: 'BidErrorCodeBidRejectedDupPhiloAudioIdent',
  BidInvalidMediafileDeliveryType: 'BidErrorCodeInvalidMediafileDeliveryType',
  BidRejectedCategoryExclusivity: 'BidErrorCodeBidRejectedCategoryExclusivity',
  BidUnwrapEOFError: 'BidErrorCodeUnwrapEOFError',
  BidRejectedCacheConnection: 'BidErrorCodeBidRejectedCacheConnection',
  BidRejectedCacheXmlEncode: 'BidErrorCodeBidRejectedCacheXMLEncode',
  BidRejectedCacheStore: 'BidErrorCodeBidRejectedCacheStore',
  BidConnectionErrorAlt: 'BidErrorCodeBidConnectionError',
  BidRejectedEventTrackerBlocklist: 'BidErrorCodeBidRejectedEventTrackerBlocklist',
  BidPriceTooHigh: 'BidErrorCodeBidPriceTooHigh',
  BidRejectedCreativeQualityAssurance: 'BidErrorCodeBidRejectedCreativeQualityAssurance',
  BidRejectedPlatformConnectionBidderSlotTargetingMismatch:
    'BidErrorCodeBidRejectedPlatformConnectionBidderSlotTargetingMismatch',
  BidRejectedBelowFloor: 'BidErrorCodeBidRejectedBelowFloor',
  CombineCreativeError: 'BidErrorCodeCombineCreativeError',
  ResponseEOFError: 'BidErrorCodeResponseEOFError',
  BidConnectionResetByPeer: 'BidErrorCodeBidConnectionResetByPeer',
  GzipReadError: 'BidErrorCodeGzipReadError',
  UnwrapParseError: 'BidErrorCodeUnwrapParseError',
  MacroReplacementErrorCode: 'BidErrorCodeMacroReplacementErrorCode',
};

export const campaignNoFillErrorKeyToTKeyMap: Record<CampaignNoFillErrorKey, TKey> = {
  NoFillUndefined: 'CampaignNoFillErrorCodeUndefined',
  EmptyVast: 'CampaignNoFillErrorCodeEmptyVast',
  FrequencyCap: 'CampaignNoFillErrorCodeFrequencyCap',
  Pacing: 'CampaignNoFillErrorCodePacing',
  SiteLoopError: 'CampaignNoFillErrorCodeSiteLoopError',
  EmptyVastMediafile: 'CampaignNoFillErrorCodeEmptyVastMediafile',
  CreativeSelectionError: 'CampaignNoFillErrorCodeCreativeSelectionError',
  ZeroDuration: 'CampaignNoFillErrorCodeZeroDuration',
  AdserverOrderNotFound: 'CampaignNoFillErrorCodeAdserverOrderNotFound',
  LowPacing: 'CampaignNoFillErrorCodeLowPacing',
  OrderFrequencyCap: 'CampaignNoFillErrorCodeOrderFrequencyCap',
  VastTimeout: 'CampaignNoFillErrorCodeVastTimeout',
  EmaPacing: 'CampaignNoFillErrorCodeEmaPacing',
  EmaPacingDataNotFound: 'CampaignNoFillErrorCodeEMAPacingDataNotFound',
};

export const auctionInsightsMiscKeyToTKeyMap: Record<string, TKey> = {
  TotalImpressions: 'Impressions',
};

export const auctionInsightsKeyToTKeyMap: Record<string, TKey> = {
  ...bidErrorKeyToTKeyMap,
  ...campaignNoFillErrorKeyToTKeyMap,
  ...auctionInsightsMiscKeyToTKeyMap,
};
